import AddIcon from '@mui/icons-material/Add'
import { Card, Grid } from '@mui/material'
import Button from '@mui/material/Button'
import dayjs from 'dayjs'
import queryString from 'query-string'
import { useCallback, useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useDispatch } from 'react-redux'
import { openModal } from '../../../../../store/reducers/modal/modal.slice'
import { AbilityContext } from '../../../../components/Ability'
import { ContentWrapper } from '../../../../components/ContentWrapper'
import Helmet from '../../../../components/Helmet'
import HeaderContent from '../../../../components/Layouts/HeaderContent'
import PageUrls from '../../../../constants/page-urls'
import useAxios from '../../../../hooks/useAxios'
import { PaginationResponseInterface } from '../../../../types/pagination'
import { IUserLists } from '../../../../types/user'
import UserFilter, { IFilterMapped } from '../../components/UserFilter'
import { UserFormModal } from '../../components/UserFormModal'
import UsersTable from '../../components/UsersTable'

const Menus: any[] = []

const UsersListPage = () => {
  const ability = useContext(AbilityContext)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const queryStr = queryString.parse(window.location.search)
  const [searchFilter, setSearchFilter] = useState<IFilterMapped>({
    page: Number(queryStr.page ?? 1),
    perPage: 15,
    search: queryStr.search?.length
      ? String(queryStr.search).toLowerCase()
      : undefined,
    startDate: queryStr.startDate
      ? dayjs(String(queryStr.startDate)).startOf('day').format()
      : undefined,
    endDate: queryStr.endDate
      ? dayjs(String(queryStr.endDate)).endOf('day').format()
      : undefined,
  })
  const [filter, setFilter] = useState<IFilterMapped>({
    page: Number(queryStr.page ?? 1),
    perPage: 15,
    search: queryStr.search?.length
      ? String(queryStr.search).toLowerCase()
      : undefined,
    startDate: queryStr.startDate
      ? dayjs(String(queryStr.startDate)).startOf('day').format()
      : undefined,
    endDate: queryStr.endDate
      ? dayjs(String(queryStr.endDate)).endOf('day').format()
      : undefined,
  })

  const onFilterChange = useCallback(
    (newFilter: IFilterMapped) => {
      setFilter(newFilter)
      // setSearchFilter(newFilter)
    },
    [setFilter],
  )

  const handleSearch = (newFilter: IFilterMapped) => {
    const filter = {
      ...newFilter,
      page: 1,
    }
    setFilter(filter)
    setSearchFilter(filter)
    const newQuery = queryString.stringify({ ...filter })
    navigate(`${PageUrls.Users}?${newQuery}`, {
      replace: true,
    })
  }

  const handlePageChange = (newFilter: IFilterMapped) => {
    setFilter(newFilter)
    setSearchFilter(newFilter)
    const newQuery = queryString.stringify({ ...newFilter })
    navigate(`${PageUrls.Users}?${newQuery}`, {
      replace: true,
    })
  }

  useEffect(() => {
    handleSearch(filter)
  }, [])

  const userList = useAxios<PaginationResponseInterface<IUserLists>>({
    method: 'GET',
    url: '/users',
    params: {
      ...searchFilter,
      search: searchFilter.search?.trim(),
    },
  })

  const onUpdateUserSuccess = useCallback(async () => {
    try {
      await userList.mutate()
    } catch (error) {}
  }, [filter])

  return (
    <ContentWrapper>
      <Helmet title="รายงานผู้ใช้งาน" />
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <HeaderContent
            goBack
            title="รายงานผู้ใช้งาน"
            routes={Menus}
            descriptions="รายการข้อมูลสมาชิกในระบบ"
            tags={[
              {
                title: 'จำนวน',
                color: 'info',
                value: userList?.data?.count ?? 0,
                classifier: 'รายการ',
              },
            ]}
          />
        </Grid>
        <Grid item>
          {ability.can('manage', 'User', 'create') && (
            <Button
              variant="contained"
              size="large"
              startIcon={<AddIcon />}
              onClick={() =>
                dispatch(
                  openModal({
                    title: 'สร้างพนักงานใหม่',
                    content: (
                      <UserFormModal
                        onUpdateUserSuccess={onUpdateUserSuccess}
                      />
                    ),
                  }),
                )
              }
            >
              สร้างพนักงานใหม่
            </Button>
          )}
        </Grid>
      </Grid>
      <Card
        sx={{
          padding: 2,
        }}
      >
        <UserFilter
          filter={filter}
          onFilterChange={onFilterChange}
          onSearch={handleSearch}
        />
        <UsersTable
          isLoading={userList.isLoading}
          data={userList.data?.records ?? []}
          onUpdateUserSuccess={onUpdateUserSuccess}
          filter={{ ...filter }}
          onFilterChange={onFilterChange}
          handlePageChange={handlePageChange}
          total={userList.data?.count ?? 0}
        />
      </Card>
    </ContentWrapper>
  )
}

export default UsersListPage
